"use client";

/**
 * PWAInstallTracker — отслеживает установку PWA-приложения.
 *
 * Слушает два браузерных события:
 *   - beforeinstallprompt: браузер показал баннер «Добавить на экран»
 *   - appinstalled: пользователь установил приложение
 *
 * Оба события попадают в:
 *   1) БД через /api/analytics (AnalyticsEvent)
 *   2) Яндекс Метрику (reachGoal)
 *   3) GTM dataLayer
 *
 * Компонент рендерит null — только side-effects.
 */

import { useEffect } from "react";
import { trackEvent } from "@/lib/marketing/events";

export function PWAInstallTracker() {
  useEffect(() => {
    let promptShownTracked = false;

    const onBeforeInstallPrompt = () => {
      if (promptShownTracked) return;
      promptShownTracked = true;
      trackEvent("pwa_prompt_shown", {
        url: window.location.pathname,
      });
    };

    const onAppInstalled = () => {
      trackEvent("pwa_install", {
        url: window.location.pathname,
      });
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    window.addEventListener("appinstalled", onAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);

  return null;
}
